import { AxiosRequestConfig } from 'axios';

import { Pagamento } from '../models/Pagamento.model';
import { yunoPaymentSession } from '../shared/store/Pagamento/yunoPayment.slice';
import { AppDispatch } from '../shared/store/store';

import Service from './Service';

class YunoService extends Service {
  static initiateCheckout(pagamento: Pagamento, config?: AxiosRequestConfig) {
    return async (dispatch: AppDispatch) => {
      try {
        const response = await this.Http.post<any>(`/yuno/sessions`, pagamento, config).then(
          this.getData
        );

        // The backend now returns { checkoutSession, merchantOrderId } inside 'data'
        dispatch(yunoPaymentSession(response.data));
      } catch (error) {
        console.error('YunoService :: Error creating checkout session', error);
      }
    };
  }

  static async createPayment(payload: {
    oneTimeToken: string;
    checkoutSession: string;
    merchantOrderId: string;
  }): Promise<any> {
    try {
      const response = await this.Http.post<any>(`/yuno/payments`, payload).then(this.getData);
      return response;
    } catch (error) {
      console.error('YunoService :: Error creating payment', error);
      throw error;
    }
  }
}

export default YunoService;
